import axios from 'axios';
const API = process.env.REACT_APP_API_BASE || 'http://127.0.0.1:8000';
function h() {
  const a = JSON.parse(localStorage.getItem('zocs_auth') || 'null');
  return a ? { Authorization: `Bearer ${a.token}` } : {};
}
export async function listImageReviewDesigns({ brand_name, clean, offset = 0, limit = 50 }) {
  const p = { offset, limit };
  if (brand_name) p.brand_name = brand_name;
  if (clean !== undefined && clean !== null) p.clean = clean;
  const r = await axios.get(`${API}/image-review/designs`, { headers: h(), params: p });
  return r.data;
}
export async function markDesignsClean(design_ids, clean) {
  const r = await axios.post(`${API}/image-review/mark`, { design_ids, clean }, { headers: h() });
  return r.data;
}
